import { render, staticRenderFns } from "./PurchaseShopManage.vue?vue&type=template&id=779f47be&"
import script from "./PurchaseShopManage.vue?vue&type=script&lang=js&"
export * from "./PurchaseShopManage.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseShopManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports